import DOMPurify from "dompurify";
import React from "react";

export const getSanitizedHtml = (html: string): JSX.Element => {
  let clean = html;

  if (!html) {
    return <></>;
  }

  if (
    DOMPurify &&
    DOMPurify.isSupported &&
    typeof DOMPurify.sanitize === "function"
  ) {
    clean = DOMPurify.sanitize(html);
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: clean,
      }}
    />
  );
};
